import React from 'react';

const PlayerRow = ({ giocatore, onUpdateGiocatore, onToggleCartellino, teamNumber }) => {
  const handleStatChange = (stat, increment) => {
    const newValue = increment ? giocatore[stat] + 1 : Math.max(0, giocatore[stat] - 1);
    onUpdateGiocatore(teamNumber, giocatore.id, stat, newValue);
  };

  const handleCartellino = (tipo) => {
    onToggleCartellino(teamNumber, giocatore.id, tipo);
  };

  return (
    <div className="match-giocatore-row">
      <div className="match-col-numero">{giocatore.n}</div>
      <div className="match-col-nome">{giocatore.maglia}</div>
      
      {/* Mete */}
      <div className="match-col-stat">
        <div className="match-stat-controls">
          <button 
            onClick={() => handleStatChange('mete', false)}
            disabled={giocatore.mete === 0}
          >
            -
          </button>
          <span style={{ color: giocatore.mete === 0 ? '#bbb' : '#000' }}>{giocatore.mete}</span>
          <button onClick={() => handleStatChange('mete', true)}>+</button>
        </div>
      </div>
      
      {/* Pieni */}
      <div className="match-col-stat">
        <div className="match-stat-controls">
          <button 
            onClick={() => handleStatChange('pieni', false)}
            disabled={giocatore.pieni === 0}
          >
            -
          </button>
          <span style={{ color: giocatore.pieni === 0 ? '#bbb' : '#000' }}>{giocatore.pieni}</span>
          <button onClick={() => handleStatChange('pieni', true)}>+</button>
        </div>
      </div>
      
      {/* Vuoti */}
      <div className="match-col-stat">
        <div className="match-stat-controls">
          <button 
            onClick={() => handleStatChange('vuoti', false)}
            disabled={giocatore.vuoti === 0}
          >
            -
          </button>
          <span style={{ color: giocatore.vuoti === 0 ? '#bbb' : '#000' }}>{giocatore.vuoti}</span>
          <button onClick={() => handleStatChange('vuoti', true)}>+</button>
        </div>
      </div>
      
      {/* Assist */}
      <div className="match-col-stat">
        <div className="match-stat-controls">
          <button 
            onClick={() => handleStatChange('assist', false)}
            disabled={giocatore.assist === 0}
          >
            -
          </button>
          <span style={{ color: giocatore.assist === 0 ? '#bbb' : '#000' }}>{giocatore.assist}</span>
          <button onClick={() => handleStatChange('assist', true)}>+</button>
        </div>
      </div>
      
      {/* Cartellini */}
      <div className="match-col-cartellini">
        <button 
          className={`match-cartellino giallo ${giocatore.giallo ? 'active' : ''}`}
          onClick={() => handleCartellino('giallo')}
          title="Cartellino Giallo"
        >
          <i className="fas fa-square"></i>
        </button>
        <button 
          className={`match-cartellino rosso ${giocatore.rosso ? 'active' : ''}`}
          onClick={() => handleCartellino('rosso')}
          title="Cartellino Rosso"
        >
          <i className="fas fa-square"></i>
        </button>
        <button 
          className={`match-cartellino nero ${giocatore.nero ? 'active' : ''}`}
          onClick={() => handleCartellino('nero')}
          title="Cartellino Nero"
        >
          <i className="fas fa-square"></i>
        </button>
      </div>
    </div>
  );
};

export default PlayerRow;